//***********************************************
// Require
var $ = require("jquery");



//***********************************************
// Variables

var $window = $(window),
    $document = $(document),
    $body = $('body');



//***********************************************
// Modules export

module.exports = function (opts) {

    //-----------------------------------------------
    // Variables  
    var $popup = null,
        options = null,
        windowWidth = 0,
        isVisible = false,
        wasFullpage = false,
        scrollPos = null;



    //-----------------------------------------------
    // Constructor

    var Construct = function (opts) {


        // Default options
        options = $.extend({
            // View used to wrap the "html"
            // The HTML returned by this function must
            // be compatible with this plugin.
            //
            // The function in the "view" should be comming
            // from a "view" module.
            view: function () {
                // Function that return jQuery object of the 
                // complete popup HTML to inject at the end 
                // of the body
                this.getHtml = function () { return $(html); },
                    // Function that return a boolean indicating
                    // in the page page content should be visible
                    // during the popup display 
                    // (used for fullpage display).
                    this.isFullpage = function () { return false; },
                    // Callback on dom ready
                    this.onDomReady = function () { },
                    // Callback on popup open
                    this.onOpen = function () { },
                    // Callback on popup close
                    this.onClose = function () { }
            },
            // jQuery object used to wrap the page .
            // The content of the page will be hidden
            // on mobile (phone).
            pageContainer: $("body > .document, body > #page"),
            // Callback on dom ready
            onDomReady: function () { },
            // Callback on open
            onOpen: function () { },
            // Callback on close
            onClose: function () { }
        }, opts);


        // Build popup HTML and append to the body
        $popup = options.view.getHtml();
        $popup.attr('data-utils-popup', '');
        $body.append($popup);


        // Manage resize event
        $window.on('resize.utils-popup', function (e) { requestAnimationFrame(OnResize); });
        OnResize(); // Not called through requestAnimationFrame because we need this ASAP.


        // Close popup on ESC key press
        $document.keyup(function (e) {
            if (e.keyCode == 27) {
                Close();
            }
        });


        // Add a method to the HTMLElement
        $popup.get(0).open = function () {
            requestAnimationFrame(Open);
        };
        $popup.get(0).close = function () {
            requestAnimationFrame(Close);
        };


        // Callback
        options.view.onDomReady();
        options.onDomReady();


    };



    //-----------------------------------------------
    // Open

    var Open = function () {

        if (isVisible) {
            return;
        }

        isVisible = true;

        $('*[data-utils-popup]').not($popup.get(0)).each(function () {
            this.close();
        });

        Update(true);

        options.view.onOpen();
        options.onOpen();
    };



    //-----------------------------------------------
    // Close

    var Close = function () {

        if (!isVisible) {
            return;
        }

        isVisible = false;

        CloseStateStyle();

        if (options.view.isFullpage()) {
            $('html, body').scrollTop(scrollPos);
            scrollPos = 0;
        }

        options.view.onClose();
        options.onClose();
    };



    //-----------------------------------------------
    // Resize

    var OnResize = function () {
        // Force close the popup on window width change
        // Retreive viewport width : http://stackoverflow.com/a/8876069
        var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        if (windowWidth != w) {
            if (windowWidth != 0) {
                requestAnimationFrame(function () { Update(false); });
            }
            windowWidth = w;
        }
    };



    //-----------------------------------------------
    // Update

    var Update = function (isOpening) {

        if (!isVisible) {
            return;
        }

        // Fullpage presentation
        if (options.view.isFullpage() && (!wasFullpage || isOpening)) {
            scrollPos = $document.scrollTop();
            OpenStateStyle();
            $('html, body').scrollTop(0);
        }

        // Regular presentation
        if (!options.view.isFullpage() && (wasFullpage || isOpening)) {
            OpenStateStyle();
            if (wasFullpage) {
                $('html, body').scrollTop(scrollPos);
                scrollPos = 0;
            }
        }

        wasFullpage = options.view.isFullpage();
    };



    //-----------------------------------------------
    // Open State Style

    var OpenStateStyle = function () {
        if (options.view.isFullpage()) {
            options.pageContainer.css({
                'display': 'none'
            });
            $body.css({
                'overflow': ''
            });
        } else {
            options.pageContainer.css({
                'display': ''
            });
            $body.css({
                'overflow': 'hidden'
            });
        }
    };



    //-----------------------------------------------
    // Close State Style

    var CloseStateStyle = function () {
        options.pageContainer.css({
            'display': ''
        });
        $body.css({
            'overflow': ''
        });
    };



    // Constructor
    Construct(opts);

    // API
    this.open = Open;
    this.close = Close;
}


// WEBPACK FOOTER //
// ./Sig.Web/src/utils/popup/index.js